import { Injectable } from '@angular/core';
import { ApiService, CommonService } from '../common';
import { apiBase } from '../../enums';


@Injectable({
    providedIn: 'root'
})
export class LoginService {
    constructor(
        private apiService: ApiService,
        private commonService: CommonService
    ) { }

    /**
     * Get user data based on login details
     *
     * @returns {Promise<any>}
     * @memberof LoginService
     */
    login = async (value = {}, nameOnly = false): Promise<any> => {
        const name = "login";
        if (nameOnly) {
            return name;
        } else {
            if (this.commonService.getAPIFlag(name)) {
                return await this.apiService.cancelCall();
            }
            else {
                this.commonService.resetAPIFlag(name, true);
                return await this.apiService.postCall(apiBase[name], JSON.stringify(value));
            }
        }
    };

    signup = async (value = {}, nameOnly = false): Promise<any> => {
        const name = "signup";

        if (nameOnly) {
            return name;
        } else {
            if (this.commonService.getAPIFlag(name)) {
                return await this.apiService.cancelCall();
            } else {
                this.commonService.resetAPIFlag(name, true);
                return await this.apiService.postCall(apiBase[name], JSON.stringify(value));
            }
        }
    };

}
